/**
 * Scrolls to the specified element on the page and focuses on it.
 *
 * The element is identified by either its `name` attribute or `data-testid` attribute.
 * The scrolling behavior can be customized to be either 'auto' or 'smooth'.
 *
 * @param {string} field - The name or data-testid of the element to scroll to.
 * @param {'auto' | 'smooth'} [scrollBehavior='smooth'] - The scrolling behavior. Defaults to 'smooth'.
 */
export const scrollToElement = (field: string, scrollBehavior: 'auto' | 'smooth' = 'smooth') => {
  const element =
    (document.querySelector(`[name="${field}"]`) as HTMLElement | null) ||
    (document.querySelector(`[data-testid="${field}"]`) as HTMLElement | null);
  element?.scrollIntoView({
    behavior: scrollBehavior,
    block: 'center',
    inline: 'nearest',
  });
  element?.focus();
};
